import { render, staticRenderFns } from "./ProductAttributes.vue?vue&type=template&id=8d0d6ee8&scoped=true"
import script from "./ProductAttributes.vue?vue&type=script&lang=js"
export * from "./ProductAttributes.vue?vue&type=script&lang=js"
import style0 from "./ProductAttributes.vue?vue&type=style&index=0&id=8d0d6ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0d6ee8",
  null
  
)

export default component.exports